// extracted by mini-css-extract-plugin
export default {"numberInput":"numberInput_numberInput__cALrV"};